import { type SnapshotId, makeTypeGuardByProperty } from '@ipfabric/utils';

export interface IdHostIdentifier {
  hostId: string;
}

export const isIdHostIdentifier = makeTypeGuardByProperty<
  HostIdentifier,
  IdHostIdentifier
>('hostId');

export interface SnHostIdentifier {
  hostSn: string;
  snapshotId: SnapshotId;
}

export const isSnHostIdentifier = makeTypeGuardByProperty<
  HostIdentifier,
  SnHostIdentifier
>('hostSn');

export interface CloudHostIdentifier {
  cloudConstructId: string;
  snapshotId: SnapshotId;
}

export const isCloudHostIdentifier = makeTypeGuardByProperty<
  HostIdentifier,
  CloudHostIdentifier
>('cloudConstructId');

export type HostIdentifier =
  | IdHostIdentifier
  | SnHostIdentifier
  | CloudHostIdentifier;
